const getDefaultState = () => {
  return {
    leadPid: null,
    activeMedications: [],
    transactions: [],
    appointmentFilters: {},
    visitFilters: {},
    consultation: {},
    invoice: {},
    patient: {},
    registration: {},
    treatments: [],
    treatmentForms: [],
    treatmentEditingStates: []
  }
}
const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations: {
    resetTreatment (state) {
      Object.assign(state, getDefaultState())
    },
    resetVisitFilters (state) {
      state.visitFilters = {}
    },
    resetTreatmentForms (state) {
      state.treatmentForms = []
    },
    resetTreatmentEditingStates (state) {
      state.treatmentEditingStates = []
    },
    setLeadPid (state, data) {
      state.leadPid = data
    },
    setPatient (state, data) {
      state.patient = data
    },
    setConsultation (state, data) {
      state.consultation = data
      state.leadPid = data.pid
      state.patient = data.patient
      state.registration = data.registration
      state.treatments = data.treatments
    },
    setInvoice (state, data) {
      state.invoice = data
      state.leadPid = data.pid
      if (data.customer) state.patient = data.customer
      state.registration = data.registration
      state.treatments = data.products
    },
    setTreatments (state, data) {
      state.consultation.treatments = data
      state.invoice.products = data
      state.treatments = data
    },
    setActiveMedications (state, data) {
      state.activeMedications = data
    },
    setTransactions (state, data) {
      state.transactions = data
    },
    updateConsultation(state, data) {
      let consultation = { ...state.consultation, ...data }
      state.consultation = consultation
      state.leadPid = consultation.pid
      state.patient = consultation.patient
      state.registration = consultation.registration
      state.treatments = consultation.treatments
    },
    updateRegistration(state, data) {
      let registration = { ...state.registration, ...data }
      state.consultation.registration = registration
      state.invoice.registration = registration
      state.registration = registration
    },
    updateVisitFilters(state, data) {
      let filters = { ...state.visitFilters, ...data }
      state.visitFilters = filters
    },
    updateAppointmentFilters(state, data) {
      let filters = { ...state.appointmentFilters, ...data }
      state.appointmentFilters = filters
    },
    updateTreatmentForms(state, data) {
      let forms = data
      state.treatmentForms = forms
    },
    updateTreatmentEditingStates(state, data) {
      let forms = data
      state.treatmentEditingStates = forms
    }
  },
  getters: {
    getConsultation (state) {
      return state.consultation
    },
    getInvoice (state) {
      return state.invoice
    },
    getRegistration (state) {
      return state.registration
    },
    getPatient (state) {
      return state.patient
    },
    getTreatments (state) {
      return state.treatments
    },
    getLeadPid (state) {
      return state.leadPid
    },
    getActiveMedications (state) {
      return state.activeMedications
    },
    getTransactions (state) {
      return state.transactions
    },
    getVisitFilters (state) {
      return state.visitFilters
    },
    getAppointmentFilters (state) {
      return state.appointmentFilters
    },
    getTreatmentForms (state) {
      return state.treatmentForms
    },
    getTreatmentEditingStates (state) {
      return state.treatmentEditingStates
    },
  }
}